"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRoundFieldProperties = exports.renderFunctionLabel = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var setRoundFieldProperties = exports.setRoundFieldProperties = function setRoundFieldProperties(_ref) {
  var member = _ref.member,
    labels = _ref.labels;
  if (!(0, _utils.isBlank)(member.dataType) && R.equals(member.dataType, _constants.DATA_TYPES.NUMERIC)) {
    return {
      placeholder: labels.FORMULA_INPUT_DECIMALS_PLACEHOLDER,
      allowSearch: false,
      allowPercentageToggler: false,
      inputType: 'number',
      searchableAction: _utils.noop,
      maxLength: _constants.NUMBER_OF_DECIMALS_MAX_LENGTH
    };
  }
  return {};
};
var renderFunctionLabel = exports.renderFunctionLabel = function renderFunctionLabel(_ref2) {
  var value = _ref2.value,
    labels = _ref2.labels;
  switch (value) {
    case _constants.FUNCTION_MEMBER_TYPES.MAX:
      return labels.FORMULA_MAX_FUNCTION_LABEL;
    case _constants.FUNCTION_MEMBER_TYPES.MIN:
      return labels.FORMULA_MIN_FUNCTION_LABEL;
    case _constants.FUNCTION_MEMBER_TYPES.ROUND:
      return labels.FORMULA_ROUND_FUNCTION_LABEL;
    case _constants.FUNCTION_MEMBER_TYPES.ROUND_UP:
      return labels.FORMULA_ROUND_UP_FUNCTION_LABEL;
    case _constants.FUNCTION_MEMBER_TYPES.ROUND_DOWN:
      return labels.FORMULA_ROUND_DOWN_FUNCTION_LABEL;
    default:
      return value;
  }
};